

import React from 'react';

import { appMethod as app } from '@utils/app';
import { pageInstance } from '@utils/page';
import { convertStyleData } from '@utils/tools';

import './SearchCustomComponent.less';

export default class SearchCustomComponent extends React.Component {
  
  state = {
    keyword: ''
  }

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }
  
  init = (compindex, pageInstance) => {
    let compData = pageInstance.data.eles[compindex];
    let searchObject = compData.customFeature.searchObject;
    if (searchObject && searchObject.type == 'topic') {
      let topicComponentIndex = app.findComponentIndexById(searchObject.customFeature.id);
      if (topicComponentIndex > -1) {
        let isShowList = pageInstance.data.eles[topicComponentIndex].customFeature.isShowList;
        pageInstance.setData({
          ['eles[' + compindex + '].searchValue']: '',
          ['eles[' + compindex + '].showCenter']: isShowList === false ? isShowList : true,
          ['eles[' + compindex + '].relateTopicCompIndex']: topicComponentIndex,
          ['eles[' + topicComponentIndex + '].relateSearchCompIndex']: compindex
        });
      } else {
        app.showModal({content: '搜索未找到绑定的话题列表'});
        pageInstance.setData({
          ['eles[' + compindex + '].searchValue']: '',
        });
      }
    }
  }
  /**
   * event
   * sevent 关联的列表组件绑定的事件（可选）
   */
  searchList = (event, sevent) => {
    let pageInstance = app.getAppCurrentPage();
    // 搜索组件的索引
    // 如果sevent存在则event为当前搜索组件的的compindex
    let compindex    = !sevent ? event.currentTarget.dataset.compindex : event;
    let compData     = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let listid       = customFeature.searchObject.customFeature.id;
    let listType     = customFeature.searchObject.type;
    let form         = customFeature.searchObject.customFeature.form;
    let keyword      = this.state.keyword || '';
    let page         = '';

    // 搜索组件绑定的列表组件的索引
    let componentIndex = app.findComponentIndexById(listid);
    if (componentIndex === -1) {
      return;
    }
    // 搜索组件绑定的列表组件的数据
    let componentData = pageInstance.data.eles[componentIndex];
    if (listType == 'group-buy-list') {
      pageInstance.callComponentMethod({
        componentIndex: componentIndex,
        methodName: 'getGroupBuyList',
        argvs: [componentIndex, {
          param: {
            page: 1,
            status: componentData.selectNum,
            search_value: keyword
          }
        }]
      });
      return;
    } else if (listType == 'news') {
      form = componentData.param.form;
      pageInstance.setData({
        ['eles[' + componentIndex + '].pageObj']: {
          isLoading: false,
          noMore: false,
          page: 1
        },
        ['eles[' + componentIndex + '].selectedCateId']: '',
        ['eles[' + componentIndex + '].newslist']: []
      });
      
      pageInstance.callComponentMethod({
        componentIndex: componentIndex,
        methodName: 'getNewsList',
        argvs: [{
          compindex: componentIndex,
          page: keyword ? -1 : 1,
          search_value: keyword
        }, (res) => {
          if (keyword) {
            setTimeout(() => {
              app.showModal({
                content: '搜索到'+ res.data.length +'条资讯'
              });
            }, 0);
          }
        }]
      });
      return;
    }

    let newdata = {};

    // 是否为滚动
    if (sevent) {
      componentData = pageInstance.data.eles[componentIndex];

      page = componentData.curpage + 1;
      // TODO: web端处理
      if(!componentData.is_more && typeof sevent == 'object' && sevent.type == 'tap'){
        app.showModal({
          content: '已经加载到最后了'
        });
      }

      if (pageInstance.requesting || !componentData.is_more) {
        return;
      }
      pageInstance.requesting = true;

    } else {
      
      page = 1;

      if (listType === 'list-vessel'){
        form = componentData.customFeature.form;
        newdata['eles[' + componentIndex + '].list_data'] = [];
      } else if (listType === 'goods-list'){
        form = componentData.customFeature.form;
        newdata['eles[' + componentIndex + '].goods_data'] = [];
      } else if (listType === 'franchisee-list'){
        form = componentData.param.form;
        newdata['eles[' + componentIndex + '].franchisee_data'] = [];
      } else if (listType === 'video-list') {
        form = componentData.param.form;
        newdata['eles[' + componentIndex + '].video_data'] = [];
      } else if (listType === 'dynamic-classify') {
        form = componentData.customFeature.form;
        newdata['eles[' + componentIndex + '].list_data'] = [];
      }
    }
    newdata['eles[' + componentIndex + '].loading'] = true;
    newdata['eles[' + componentIndex + '].loadingFail'] = false;
    pageInstance.setData(newdata);


    let url = '/index.php?r=appData/search';
    let param = {
      "search":{
        "data":[{"_allkey":keyword,"form": form}],
        "app_id": app.getAppId()
      },
      no_wrap: listType === 'video-list' || listType === 'franchisee-list' ? 1 : '',
      page_size: componentData.customFeature.loadingNum || 20,
      page: page
    };

    if (listType === 'franchisee-list'){
      let info = app.getLocationInfo();
      param.search.longitude = info.longitude;
      param.search.latitude = info.latitude;
    }

    app.sendRequest({
      url: url,
      data: param,
      hideLoading: true,
      chain: listType !== 'franchisee-list' ? true : '',
      success: function (res) {
        let newdata = {};
        if(res.data.length == 0){
          setTimeout(function () {
            app.showModal({
              content: '没有找到与“'+keyword+'”相关的内容'
            });
          },0);
        }
        if (listType === "goods-list") {
          newdata['eles[' + componentIndex + '].goods_data'] = page == 1 ? res.data : componentData.goods_data.concat(res.data);
        } else if (listType === 'list-vessel' || listType == 'dynamic-classify') {
          if (componentData.classifyType == "level1-vertical-withpic" || componentData.classifyType == "level2-vertical-withpic") {
            app.turnToPage(`classifyGoodsListPage?form=${form}&isShoppingCart=true& isBuyNow=false&search=${keyword}`);
          }
          let listField = componentData.listField;
          for (let j in res.data) {
            for (let k in res.data[j].form_data) {
              if (k == 'category') {
                continue;
              }
              if (/region/.test(k)) {
                continue;
              }
              if(k == 'goods_model') {
                res.data[j].form_data.virtual_price = app.formVirtualPrice(res.data[j].form_data);
              }
              let description = res.data[j].form_data[k];
              if (listField && listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) { //没有绑定的字段的富文本置为空
                res.data[j].form_data[k] = '';
              }else if(app.needParseRichText(description)) {
                res.data[j].form_data[k] = app.getWxParseResult(description);
              }
            }
          }
          newdata['eles[' + componentIndex + '].list_data'] = page == 1 ? res.data : componentData.list_data.concat(res.data);
        } else if (listType === 'franchisee-list') {
          for(let index in res.data){
            let distance = res.data[index].distance;
            res.data[index].distance = util.formatDistance(distance);
          }
          newdata['eles[' + componentIndex + '].franchisee_data'] = page == 1 ? res.data : componentData.franchisee_data.concat(res.data);
        }else if(listType == 'video-list'){
          let rdata = res.data;

          for (let i = 0; i < rdata.length; i++) {
            rdata[i].video_view = app.handlingNumber(rdata[i].video_view);
          }
          newdata['eles[' + componentIndex + '].video_data'] = page == 1 ? rdata : componentData.video_data.concat(rdata);

        }

        newdata['eles[' + componentIndex + '].is_search'] = true;
        newdata['eles[' + componentIndex + '].searchEle'] = compindex;
        newdata['eles[' + componentIndex + '].is_more']   = res.is_more;
        newdata['eles[' + componentIndex + '].curpage']   = res.current_page;
        newdata['eles[' + componentIndex + '].loading'] = false;
        newdata['eles[' + componentIndex + '].loadingFail'] = false;

        pageInstance.setData(newdata);

      },
      fail: function (err) {
        let newdata = {};
        newdata['eles[' + componentIndex + '].loadingFail'] = true;
        newdata['eles[' + componentIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    })
  }

  searchForTopicAct = (e) => {
    let currentTarget = e.currentTarget;
    let dataset = currentTarget.dataset;
    let compindex = dataset.compindex;
    let topicCompIndex = dataset.topicCompindex;
    let search_value = e.target.value;
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};

    if (topicCompIndex > -1) {
      let classifyCompIndex = pageInstance.data.eles[topicCompIndex].relateClassifyCompIndex;

      newdata['eles[' + compindex + '].searchValue'] = search_value;
      newdata['eles[' + topicCompIndex + '].listStatus.loading'] = false;
      newdata['eles[' + topicCompIndex + '].listStatus.isMore'] = true;
      newdata['eles[' + topicCompIndex + '].listParam.section_id'] = '';
      newdata['eles[' + topicCompIndex + '].listParam.category_id'] = '';

      if (classifyCompIndex > -1) {
        newdata['eles[' + classifyCompIndex + '].selectedSectionId'] = '';
        newdata['eles[' + classifyCompIndex + '].selectedCategoryId'] = '';
      }
      newdata['eles[' + topicCompIndex + '].listParam.search_value'] = search_value;
      newdata['eles[' + topicCompIndex + '].listParam.page'] = -1;
      pageInstance.setData(newdata);
      pageInstance.callComponentMethod({
        componentIndex: topicCompIndex,
        methodName: 'getTopListData',
        argvs: [topicCompIndex, pageInstance, (data) => {
          app.showModal({
            content: '搜索到' + data.length + '条话题'
          });
        }]
      });
    } else {
      app.showModal({content: '搜索未找到绑定的话题列表'});
    }
  }

  turnToTopicUserCenter = (e) => {
    app.turnToPage('communityUsercenter?detail=');
  }

  turnToTopicNotify = (e) => {
    app.turnToPage('communityNotify?detail=');
  }

  turnToFranchiseeSearchPage = (e) => {
    app.turnToPage('franchiseeSearch');
  }

  turnToSearchPage = (e) => {
    app.turnToSearchPage(e);
  }

  /**
   * 触发input值的变化
   */
  handleChange = (event) => {
    this.setState({
      value: event.target.value
    })
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    /**
     * 页面上的数据
     */
    const userInfo = pageInstance.data.userInfo || {};   // 用户信息
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    let styleObj = {};
    /**
     * 组件内容处理
     */   
    let content = data.content;
    // 搜索组件类型
    const type = (customFeature.searchObject && customFeature.searchObject.type === 'topic') ? '0' : '1';
    let  ifLocation = false;
    if (type === '0') {
      let style = data.style;
      // 话题列表搜索组件styleObj特殊处理
      styleObj = convertStyleData({
        width:  style.width,
        height: style.height,
        background: style.background,
        backgroundColor: style['background-color'] || style['backgroundColor'] ,
        marginTop: style['margin-top'] || style['marginTop'],
      });
    } else {
      styleObj = convertStyleData(data.style);
    }
    if (type === '1' && customFeature.ifLocation) {
      ifLocation = true;
    }
    /**
     * 返回组件
     */
    return (
      <div className={`custom-component search type-${type} ${ifLocation ? 'has-location': ''}`} style={styleObj}>
        {/* 话题列表搜索组件 */}
        {
          type === '0' && 
          <React.Fragment>
            <div className="search-input-label">
              <span className="ico-moon icon-search"></span>
              <input className="search-input" type="text"
                onBlur={(e) => this.searchForTopicAct(e)}
                data-compindex={this.props.index}
                data-topic-id={data.customFeature.searchObject.id}
                data-topic-compindex={data.relateTopicCompIndex}
                placeholder={content.placeholder}/>
            </div>
            {
              !!data.showCenter &&
              (
                <React.Fragment>
                  <div className="search-usercenter" onClick={this.turnToTopicUserCenter} >
                    <img src={userInfo.cover_thumb}/>
                  </div>
                  <div className="ico-moon icon-community_notify search-notify" onClick={this.turnToTopicNotify} ></div>
                </React.Fragment>
              )
            }
          </React.Fragment>
        }
        {/* 普通搜索组件 */}
        {
          type === '1' && 
          <React.Fragment>
            {
              ifLocation &&
              <div className="ico-moon icon-location location"
                onClick={this.turnToSearchPage}
                data-param={customFeature.ifLocation}
                data-listid={customFeature.searchObject.customFeature.id} 
              >全国</div>}
            <div className="search-input">
              <span className="ico-moon icon-search"></span>
              {
                customFeature.searchObject && customFeature.searchObject.type=='goods-list' && 
                <div className="fake-search"
                  onClick={this.turnToSearchPage}
                  data-form={customFeature.searchObject.customFeature.form}
                  data-listid={customFeature.searchObject.customFeature.id}
                ></div>
              }
              {
                customFeature.searchObject && customFeature.searchObject.type=='franchisee-list' && 
                <div className="fake-search"
                  onClick={this.turnToFranchiseeSearchPage}
                ></div>
              }
              <input type="text" value={this.state.keyword} onChange={this.handleChange} placeholder={content.placeholder} />
              {
                customFeature.searchObject &&
                <div className="search-btn"
                  onClick={this.searchList}
                  data-compindex={ this.props.index }
                  data-listid={customFeature.searchObject.customFeature.id}
                  data-listtype={customFeature.searchObject && customFeature.searchObject.type}
                  data-form={customFeature.searchObject.customFeature.form}
                >搜索</div>
              }
            </div>
          </React.Fragment>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/search-custom-component/SearchCustomComponent.jsx